//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const MatchSignupPayment = require('@/tbs/model/to/MatchSignupPayment')
const matchSignupPayment = new MatchSignupPayment
/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchSignupStaffConfig = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSignupStaffConfig.prototype = {
    /* The view object name */
    name: 'matchGroup',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchTeamOfficerSignupSetting',
            query: {
                matchId: 'id',
            },
            basePath: 'data',
            rule: {
                id: '$id',
                isStaffOn: '@required',
                staffNumMin: 'minCount',
                staffNumMax: 'maxCount',
                isIdentificationNumRequired: '@certRequired',
                isPhotoRequired: '@avatarRequired',
                staffDutyItems: '$roleFields',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchTeamOfficerSignupSetting',
            basePath: '',
            rule: {
                matchId: 'id',
                required: '#isStaffOn',
                minCount: 'staffNumMin',
                maxCount: 'staffNumMax',
                certRequired: '#isIdentificationNumRequired',
                avatarRequired: '#isPhotoRequired',
                roleFields: '$staffDutyItems',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderId: function(id, options) {
        return options.parameters.matchId
    },
    renderStaffDutyItems: function(roleFields) {
        roleFields = roleFields || ''
        const itemArr = roleFields.split(',')
        const items = []
        for (let i = 1; i < 6; i++) {
            let label = matchSignupPayment.localeProp('staff-role-type-' + i)
            let index = itemArr.indexOf(label)
            if (index > -1) {
                itemArr.splice(index, 1)
            }
            items.push({
                label: label,
                selected: (index > -1)
            })
        }
        for (let i = 0; i < itemArr.length; i++) {
            let item = itemArr[i]
            if (item) {
                items.push({
                    label: item,
                    selected: true
                })
            }
        }
        console.log('@items', items)
        return items
    },
    formatRoleFields: function(staffDutyItems) {
        return ObjectFunc.convertSelectedItemArray2String(staffDutyItems)
    },
    getDefaultStaffDutyItems() {
        const items = []
        for (let i = 1; i < 6; i++) {
            let label = matchSignupPayment.localeProp('staff-role-type-' + i)
            items.push({
                label: label,
                selected: true
            })
        }
        return items
    },
}

module.exports = tbs_model_vo_MatchSignupStaffConfig